module.exports = __webpack_public_path__ + "static/media/usdc.7fa63868.svg";